import { pickIntent } from "./helpers/ui.js";
import './assets/constants2.css';const root = "_root_ezy6m_2";
const withTheme = "_withTheme_ezy6m_41";
const iconWrapper = "_iconWrapper_ezy6m_57";
const regular = "_regular_ezy6m_62";
const primary = "_primary_ezy6m_68";
const secondary = "_secondary_ezy6m_82";
const critical = "_critical_ezy6m_96";
const warning = "_warning_ezy6m_96";
const disabled = "_disabled_ezy6m_146";
const inline = "_inline_ezy6m_154";
const contentContainer = "_contentContainer_ezy6m_245";
const content = "_content_ezy6m_245";
const fill = "_fill_ezy6m_271";
const uppercase = "_uppercase_ezy6m_278";
const s = {
  root,
  withTheme,
  iconWrapper,
  regular,
  primary,
  secondary,
  critical,
  warning,
  disabled,
  inline,
  contentContainer,
  content,
  fill,
  uppercase
};
const BUTTON_INTENT = pickIntent(["primary", "secondary", "critical", "warning"]);
const BUTTON_INTENT_CLASSNAME_MAP = {
  [BUTTON_INTENT.PRIMARY]: s.primary,
  [BUTTON_INTENT.SECONDARY]: s.secondary,
  [BUTTON_INTENT.CRITICAL]: s.critical,
  [BUTTON_INTENT.WARNING]: s.warning
};
export {
  BUTTON_INTENT as B,
  BUTTON_INTENT_CLASSNAME_MAP as a,
  s
};
